const state = {
  showCookieModal: false,
  isShowed: false,
  isShowedAttention: false,
};

const mutations = {
  setIsShowed(localState, newIsShowed) {
    localState.isShowed = newIsShowed;
  },
  setIsShowedAttention(localState, newIsShowedAttention) {
    localState.isShowedAttention = newIsShowedAttention;
  },
  setShowCookieModal(localState, newShowCookieModal) {
    localState.showCookieModal = newShowCookieModal;
  },
};

const actions = {
  selectIsShowed({ commit }, isShowed) {
    commit('setIsShowed', isShowed);
  },
  selectIsShowedAttention({ commit }, isShowedAttention) {
    commit('setIsShowedAttention', isShowedAttention);
  },
  selectShowCookieModal({ commit }, showCookieModal) {
    commit('setShowCookieModal', showCookieModal);
  },
};

export default {
  mutations,
  actions,
  state,
};
